/**
 * Generates the column headers based on the active tab (pending/History) and category data.
 *
 * @param {string} tabActive - The active tab identifier. Either "1" for pending or "2" for history.
 * @param {Array} categoryData - The array of category data objects.
 * @returns {Array} The column headers array.
 */

export const getColumnConfig = (wardsData) => {
  const baseColumns = [
    {
      key: "first_name",
      title: "Name",
      avatar: true,
      filter: "searchName",
      width: 220,
    },
    {
      key: "email",

      title: "Email",
      filter: "searchMail",
      width: 237,
      avatar: true,
    },
    {
      title: "contact  INFO",
      filter: "searchPhone",
      width: 150,
      avatar: true,
      key: "phone_number",
    },
    {
      title: "Ward",
      filter: "selectWards",
      dropDown: wardsData?.map((data) => ({
        name: data?.wardName,
        value: data?.wardCode,
      })),
      width: 150,
      key: "ward_code",

      chip: true,
    },
    {
      title: "Status",
      filter: "selectStatus",
      dropDown: [
        { value: 2, name: "All" },
        { value: 1, name: "Active" },
        { value: 0, name: "Inactive" },
      ],
      width: 125,
      key: "councilor_status_flg",
      chip: true,
    },

    {
      title: "TERM",
      filter: "termPicker",
      width: 220,
      key: "term",
    },
  ];

  // if selected tab is historyTab, then return baseColumns + publishedDateColumn and expiryDateColumn
  // else return baseColumns + expiryDateColumn
  return baseColumns;
};
